Application.Branding.LinkedinPictureTransformer = {
    ui: {
        container: '.js-bli-pp-transformer',
        imageContainer: '.js-bli-pp-transformer__container',
        transformer: '.js-bli-pp-transformer__transformer',
        image: '.js-bli-pp-transformer__image',
        mask: '.js-bli-pp-transformer__mask',
        ui: '.img-transform__ui',
        move: '.img-transform__move',
        resize: '.img-transform__resize',
        inputs: {
            x: '.js-bli-pp-transformer__input--x',
            y: '.js-bli-pp-transformer__input--y',
            width: '.js-bli-pp-transformer__input--width',
            height: '.js-bli-pp-transformer__input--height',
        }
    },
    handlers: {
        move: [],
        resize: [],
        stop: []
    },
    scale: 1,
    ready: function () {

        var self = this;

        // bind
        this.bind();
        // init
        this.initSize(function(){
            $(self.ui.container).removeClass('step-preview_loading');
        });

    },
    initSize: function(callback){

        var self = this;

        var $container = $(this.ui.imageContainer);
        var $image = $(this.ui.image);
        var $transformer = $(this.ui.transformer);

        var image = new Image();
        image.onload = function() {
            if ($container.width() / $container.height() > this.width / this.height){
                var w = $container.outerWidth();
                var h = $container.outerWidth() * this.height / this.width;
            }else{
                var w = $container.outerHeight() * this.width / this.height;
                var h = $container.outerHeight();
            }
            // resize
            $transformer.css({
                'width': w,
                'height': h
            });
            // save size
            $image.attr('data-natural-width', this.width);
            $image.attr('data-natural-height', this.height);
            // callback
            if (callback){
                callback();
            }
            self.trigger('resize', [0, 0, w, h])
        }
        image.src = $image.attr('src');

    },
    bind: function(){

        var self = this;

        // move
        $(document).on('mousedown', this.ui.move, self.onMoveStart.bind(this));
        $(document).on('touchstart', this.ui.move, self.onMoveStart.bind(this));

        // resize
        $(document).on('mousedown', this.ui.resize, self.onResizeStart.bind(this));
        $(document).on('touchstart', this.ui.resize, self.onResizeStart.bind(this));

        // update inputs
        this.on('resize', function(x, y, width, height){
            $(self.ui.inputs.width).val(Math.round(width * 2));
            $(self.ui.inputs.height).val(Math.round(height * 2));
            $(self.ui.inputs.x).val(Math.round(x * 2));
            $(self.ui.inputs.y).val(Math.round(y * 2));
        })
        this.on('move', function(x, y){
            $(self.ui.inputs.x).val(Math.round(x * 2));
            $(self.ui.inputs.y).val(Math.round(y * 2));
        })

    },
    onMoveStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // handlers
        var move = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.move((x - x1) / self.scale, (y - y1) / self.scale);
            // update state
            x = x1;
            y = y1;
        };
        var moveEnd = function(){
            $(document).off('mousemove', move);
            $(document).off('touchmove', move);
            $(document).off('mouseup', moveEnd);
            $(document).off('touchend', moveEnd);
        };

        // bind
        $(document).on('mousemove', move);
        $(document).on('touchmove', move);
        $(document).on('mouseup', moveEnd);
        $(document).on('touchend', moveEnd);

    },
    onResizeStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // direction
        var direction = $(event.target).data('direction');

        // handlers
        var resize = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.resize(direction, (x - x1) / self.scale, (y - y1) / self.scale);
        };
        var resizeEnd = function(){
            $(document).off('mousemove', resize);
            $(document).off('touchmove', resize);
            $(document).off('mouseup', resizeEnd);
            $(document).off('touchend', resizeEnd);
            // commit
            self.resizeCommit()
        };

        // bind
        $(document).on('mousemove', resize);
        $(document).on('touchmove', resize);
        $(document).on('mouseup', resizeEnd);
        $(document).on('touchend', resizeEnd);

    },
    move: function(x, y){

        // elements
        var $imageContainer = $(this.ui.imageContainer);
        var $transformer = $(this.ui.transformer);

        // retrieve current values
        var left = parseFloat($transformer.css('left'));
        var top = parseFloat($transformer.css('top'));
        var width = $transformer.width();
        var height = $transformer.height();
        var containerWidth = $imageContainer.outerWidth();
        var containerHeight = $imageContainer.outerHeight();

        // do not allow to pass the edge values
        var newX = left - x;
        newX = newX > 0 ? 0 : newX;
        newX = newX + width < containerWidth ? containerWidth - width : newX;
        var newY = top - y;
        newY = newY > 0 ? 0 : newY;
        newY = newY + height < containerHeight ? containerHeight - height : newY;

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px'
        });

        // handlers
        this.trigger('move', [newX, newY]);

    },
    resize: function(direction, x, y){

        // elements
        var $imageContainer = $(this.ui.imageContainer);
        var $transformer = $(this.ui.transformer);

        // set base values
        if (!$transformer.data('resize-base-initiated')){
            $transformer.data('resize-base-initiated', true);
            $transformer.data('resize-base-x', parseFloat($transformer.css('left')));
            $transformer.data('resize-base-y', parseFloat($transformer.css('top')));
            $transformer.data('resize-base-w', $transformer.width());
            $transformer.data('resize-base-h', $transformer.height());
        }
        // retrieve base values
        var left = $transformer.data('resize-base-x');
        var top = $transformer.data('resize-base-y');
        var width = $transformer.data('resize-base-w');
        var height = $transformer.data('resize-base-h');
        var containerWidth = $imageContainer.outerWidth();
        var containerHeight = $imageContainer.outerHeight();

        // resize based ond the direction
        switch (direction){
            case 'br':
                var newW = width - x;
                var newH = height - y;
                break;
            case 'b':
                var newH = height - y;
                var newW = newH * width / height;
                break;
            case 'bl':
                var newW = width + x;
                var newH = height - y;
                break;
            case 'r':
                var newW = width - x;
                var newH = newW * height / width;
                break;
            case 'l':
                var newW = width + x;
                var newH = newW * height / width;
                break;
            case 'tr':
                var newW = width - x;
                var newH = height + y;
                break;
            case 't':
                var newH = height + y;
                var newW = newH * width / height;
                break;
            case 'tl':
                var newW = width + x;
                var newH = height + y;
                break;
        }

        // min and max sizes
        var maxW = $(this.ui.image).attr('data-natural-width') / 2;
        var maxH = $(this.ui.image).attr('data-natural-height') / 2;
        newW = newW < containerWidth ? containerWidth: newW;
        newW = newW > maxW ? maxW : newW;
        newH = newH < containerHeight ? containerHeight: newH;
        newH = newH > maxH ? maxH : newH;

        // preserve aspect ratio
        var ar = width / height;
        if (ar > newW / newH){
            newW = ar * newH;
        }else{
            newH = newW / ar;
        }

        // reposition based ond the direction
        switch (direction){
            case 'br':
                var newX = left;
                var newY = top;
                break;
            case 'b':
                var newX = left;
                var newY = top;
                break;
            case 'bl':
                var newX = left - (newW - width);
                var newY = top;
                break;
            case 'r':
                var newX = left;
                var newY = top;
                break;
            case 'l':
                var newX = left - (newW - width);
                var newY = top;
                break;
            case 'tr':
                var newX = left;
                var newY = top - (newH - height);
                break;
            case 't':
                var newX = left;
                var newY = top - (newH - height);
                break;
            case 'tl':
                var newX = left - (newW - width);
                var newY = top - (newH - height);
                break;
        }

        // do not allow to pass the edge values
        newX = newX > 0 ? 0 : newX;
        newX = newX + newW < containerWidth ? containerWidth - newW : newX;
        newY = newY > 0 ? 0 : newY;
        newY = newY + newH < containerHeight ? containerHeight - newH : newY;

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px',
            width: newW + 'px',
            height: newH + 'px',
        });

        // handlers
        this.trigger('resize', [newX, newY, newW, newH]);

    },
    resizeCommit: function(){

        var $transformer = $(this.ui.transformer);

        $transformer.data('resize-base-initiated', false);
        $transformer.data('resize-base-x', null);
        $transformer.data('resize-base-y', null);
        $transformer.data('resize-base-w', null);
        $transformer.data('resize-base-h', null);

    },
    setPosition: function(x, y, width, height){

        $(this.ui.transformer).css({
            left: (x / 2) + 'px',
            top: (y / 2) + 'px',
            width: (width / 2) + 'px',
            height: (height / 2) + 'px'
        });

    },
    setScale: function(scale){

        this.scale = scale;

    },
    on: function(event, callback){

        if (typeof this.handlers[event] !== 'undefined'){
            this.handlers[event].push(callback);
        }

    },
    trigger: function(event, args){

        if (typeof this.handlers[event] !== 'undefined'){
            for (var z in this.handlers[event]){
                if (!this.handlers[event].hasOwnProperty(z)){
                    continue;
                }
                this.handlers[event][z].apply(this, args);
            }
        }

    }
};